module.exports = __webpack_public_path__ + "img/25.46388d53.svg";